
  import { Vue, Component, Prop } from "vue-property-decorator";

  import GET_LANGUAGES from "@/apollo/autocomplete-queries/GetLanguages.gql";

  import DropdownFilter from "@/components/filters/DropdownFilter.vue";

  import DropdownOption from "@/entities/DropdownOption";
  import { Query_RootLanguageArgs } from "@/generated/graphql";

  @Component({
    components: {
      DropdownFilter,
    },
    apollo: {
      languages: {
        query: GET_LANGUAGES,
        variables() {
          return this.languageAutocompleteFilter;
        },
        update(data) {
          return data.language;
        },
        skip() {
          return !this.languageSearchString;
        },
      },
    },
  })
  export default class LanguagesMultiselect extends Vue {
    @Prop({ type: Array, required: true }) value!: any[]; // Changed from DropdownOption[] to support proficiency_level
    @Prop({ type: Boolean, default: true }) withBorder!: boolean;
    @Prop({ type: Number, default: 1000 }) limit!: number;
    @Prop({ type: Number, default: undefined }) readonly max?: number;

    languages: DropdownOption[] = [];
    languageSearchString: string = "";

    get mappedLanguagesValue(): String[] {
      return this.value.map((item) => item.name);
    }

    get selectedLanguagesForDropdown(): DropdownOption[] {
      // Return empty array so the dropdown doesn't show selected languages as pills
      // The selected languages are shown below with proficiency dropdowns
      return [];
    }

    get languageAutocompleteFilter(): Query_RootLanguageArgs {
      const conditions: any[] = [
        {
          name: {
            _ilike: `%${this.languageSearchString}%`,
          },
        },
      ];

      if (this.mappedLanguagesValue.length) {
        conditions.push({
          name: {
            _nin: this.mappedLanguagesValue,
          },
        });
      }

      return {
        where: { _and: conditions },
        limit: this.limit,
      };
    }

    handleLanguageSelection(selectedLanguages: DropdownOption[]) {
      // When a new language is selected, add it with default proficiency level 3 (Conversational)
      const newLanguages = selectedLanguages.filter(lang => 
        !this.value.some(existing => existing.id === lang.id)
      );
      
      const updatedValue = [
        ...this.value,
        ...newLanguages.map(lang => ({
          ...lang,
          proficiency_level: 3 // Default to Conversational
        }))
      ];
      
      this.$emit("input", updatedValue);
    }

    updateProficiency(languageId: string | number, proficiencyLevel: string) {
      const updatedValue = this.value.map(lang => 
        lang.id === languageId 
          ? { ...lang, proficiency_level: parseInt(proficiencyLevel) }
          : lang
      );
      this.$emit("input", updatedValue);
    }

    removeLanguage(languageId: string | number) {
      const updatedValue = this.value.filter(lang => lang.id !== languageId);
      this.$emit("input", updatedValue);
    }
  }
